import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Highcharts from "highcharts/highcharts.js";
import highchartsMore from "highcharts/highcharts-more.js"
import solidgauge from "highcharts/modules/solid-gauge.js";
import HighchartsReact from "highcharts-react-official";
import './ActivityTracker.css';
import { IconButton, IconMenu, MenuItem } from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import ImageCenterFocusStrong from 'material-ui/svg-icons/image/center-focus-strong';
import Chip from 'material-ui/Chip';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import moment from 'moment';


class StepColumns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            chartId: 0
        }
    }

    componentDidMount() {

        Highcharts.setOptions({
            lang: {
                numericSymbols: null //otherwise by default ['k', 'M', 'G', 'T', 'P', 'E']
            }
        });

        this.setState(
            {
                weekChart: this.weekChartOptions(this.props.week),
                monthChart: this.monthChartOptions(this.props.month),
                averageStepsPerDayWeek:this.getAverage(this.props.week),
                averageStepsPerDayMonth:this.getAverage(this.props.month),
                dateStringWeek:this.getDateString(this.props.week),
                dateStringMonth:this.getDateString(this.props.month),
            },
            () => { this.setState({ loading: false }) }
        )

    }

    getDateString = (data) => {
        const months = ['Jan', 'Feb', 'Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
        const end = new Date(data[data.length-1].ActivityDate);
        const start = new Date(data[0].ActivityDate)
        const endMonth = months[end.getMonth()]
        const startMonth = months[start.getMonth()]

        if(endMonth === startMonth && start.getFullYear() === end.getFullYear()){
            return `${startMonth} ${start.getDate()} - ${end.getDate()}, ${end.getFullYear()}`
        }
        else if(endMonth !== startMonth && start.getFullYear() === end.getFullYear()){
            return `${startMonth} ${start.getDate()}-${endMonth} ${end.getDate()}, ${end.getFullYear()}`
        }
        else {
            return `${startMonth} ${start.getDate()}, ${start.getFullYear()}-${endMonth} ${end.getDate()}, ${end.getFullYear()}`
        }
    }

    getAverage = (data) => {
        let average = data.reduce(function (avg, value, _, { length }) {
            return avg + value.Value / length;
        }, 0)

        return (Math.round(average)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    weekChartOptions = (data) => {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

        return {
            chart: {
                type: 'column',
                height: '150px',
                backgroundColor: 'none',
            },
            title: {
                text: null,
            },

            subtitle: {
                text: null,
            },

            xAxis: {
                categories: data.map((v, i) => { return days[new Date(v.ActivityDate).getDay()] }),
                lineWidth: 0,
                minorGridLineWidth: 0,
                minorTickLength: 0,
                tickLength: 0
            },

            yAxis: {
                min: 0,
                max:this.props.goal * 2,
                title: {
                    text: null
                },
                plotLines: [{
                    color: '#C8C3C3',
                    width: 2,
                    value: this.props.goal * 2
                },{
                    color: '#E85E56',
                    width: 2,
                    value: this.props.goal
                },{
                    width: 5,
                    value: 0,
                    color: getMuiTheme(window.muiTheme).palette.primary1Color,
                }],
                label:{
                    format:'${text}'
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                alternateGridColor: null,
                tickWidth:0,
            },

            tooltip: {
                enabled: false,
            },

            plotOptions: {
                column: {
                    color: getMuiTheme(window.muiTheme).palette.primary1Color,
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },

            series: [{
                showInLegend: false,
                name: null,
                // pointStart:data[0].ActivityDate,
                // pointInterval: 24*60*60*1000,
                data: data.map((v, i) => v.Value),
            }]
        }

    }

    monthChartOptions = (data) => {

        return {
            chart: {
                type: 'column',
                height: '150px',
                backgroundColor: 'none',
                zoomType:'none',
            },
            title: {
                text: null,
            },

            subtitle: {
                text: null,
            },

            xAxis: {
                categories: data.map((v, i) => { return moment(v.ActivityDate).format('D') }),
                lineWidth: 0,
                minorGridLineWidth: 0,
                minorTickLength: 0,
                tickLength: 0,
                tickInterval:7,
            },
            yAxis: {
                max:this.props.goal * 2,
                min: 0,
                title: {
                    text: null
                },
                label:{
                    format:'${text}'
                },
                plotLines: [{
                    color: '#C8C3C3',
                    width: 2,
                    value: this.props.goal * 2
                },{
                    color: '#E85E56',
                    width: 2,
                    value: this.props.goal
                },{
                    width: 5,
                    value: 0,
                    color: getMuiTheme(window.muiTheme).palette.primary1Color,
                }],
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                alternateGridColor: null,
            },

            tooltip: {
                enabled: false,
            },

            plotOptions: {
                column: {
                    color: getMuiTheme(window.muiTheme).palette.primary1Color,
                    pointPadding: 0.2,
                    borderWidth: 0,
                    grouping: false,
                }
            },

            series: [{
                showInLegend: false,
                name: null,
                data: data.map((v, i) => v.Value),
            }]
        }
    }



    render() {

        const { 
            loading, 
            weekChart, 
            monthChart, 
            chartId, 
            dateStringWeek, 
            dateStringMonth,
            averageStepsPerDayMonth,
            averageStepsPerDayWeek
        } = this.state;

        return (
            <div className={'activity-history-container grey-font'}>
                <div className={'activity-chart-header-container'}>
                    <div className={'activity-header'}>Step History</div>
                    <div className={'activity-sub-header-right'}>{chartId === 0 ? dateStringWeek : dateStringMonth}</div>
                </div>
                <div className={'activity-chart-header-container'}>
                    <div className={'activity-sub-header-left'}>Avg. Steps :  {chartId === 0 ? averageStepsPerDayWeek : averageStepsPerDayMonth}/day</div>
                    <div className={'activity-chip-container'}>
                        <div className={'activity-chip'}><Chip labelStyle={{color:'inherit'}} backgroundColor={chartId === 0 ? '#FFFFFF' : 'rgba(0,0,0,0)'} onClick={() => { this.setState({ chartId: 0 }) }}>Weekly</Chip></div>
                        <div className={'activity-chip'}><Chip labelStyle={{color:'inherit'}} backgroundColor={chartId === 1 ? '#FFFFFF' : 'rgba(0,0,0,0)'} onClick={() => { this.setState({ chartId: 1 }) }}>Monthly</Chip></div>
                    </div>
                </div>
                <div>
                {loading === false && chartId === 0 &&
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={weekChart}
                    />
                }
                {loading === false && chartId === 1 &&
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={monthChart}
                    />
                }
                </div>
            </div>
        )
    }
}

export default StepColumns;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/StepColumns.js